import { Panel, trendClass, trendGlyph } from "../Panel"
import type { LaneRow } from "../dashboard-types"
import { useRegion } from "../store"

export function LaneInstability({ lanes, demo }: { lanes: LaneRow[]; demo?: boolean }) {
  const openRegion = useRegion((s) => s.openRegion)
  return (
    <Panel title="Lane Instability" demo={demo} helpText="Composite 0–100 score per major shipping/air corridor">
      <div>
        {lanes.map((l) => {
          const dot =
            l.score >= 75 ? "bg-red-500" :
            l.score >= 55 ? "bg-orange-500" :
            l.score >= 30 ? "bg-amber-500" :
            "bg-emerald-500"
          return (
            <div
              key={l.id}
              role="button"
              tabIndex={0}
              onClick={() => openRegion(l.region)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  openRegion(l.region)
                }
              }}
              className="px-3 py-2 border-b border-[color:var(--border)] last:border-b-0 cursor-pointer hover:bg-[color:var(--surface-hover)] transition-colors focus:outline-none focus:bg-[color:var(--surface-hover)]"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 min-w-0">
                  <span className={`w-2 h-2 rounded-full ${dot}`} />
                  <span className="text-sm text-[color:var(--text)] truncate">{l.label}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm tabular-nums font-semibold">{l.score}</span>
                  <span className={`text-sm ${trendClass(l.trend)}`}>{trendGlyph(l.trend)}</span>
                </div>
              </div>
              <div className="mt-1 h-1 w-full bg-[color:var(--border)] rounded overflow-hidden">
                <div
                  className={`h-1 ${dot}`}
                  style={{ width: `${l.score}%` }}
                />
              </div>
              <div className="mt-1 flex gap-3 text-[9px] text-[color:var(--text-dim)] uppercase tracking-wider">
                {Object.entries(l.components).map(([k, v]) => (
                  <span key={k}>
                    {k[0]}:<span className="text-[color:var(--text-muted)] ml-0.5">{v}</span>
                  </span>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </Panel>
  )
}
